import { Layout } from "@/components/Layout";
import { SEO } from "@/components/SEO";

const TermsOfService = () => {
  return (
    <Layout>
      <SEO
        title="Terms & Conditions | Missed Call Rescue"
        description="Terms and Conditions for Missed Call Rescue services."
        canonical="/terms-of-service"
      />
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold text-slate-900 mb-4">Terms & Conditions</h1>
        <p className="text-slate-500 mb-8">Last Updated: {new Date().toLocaleDateString()}</p>
        
        <div className="prose prose-slate max-w-none space-y-6 text-slate-700">
          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing and using Missed Call Rescue's website and services, you accept and agree to be bound by the terms 
              and provision of this agreement. In addition, when using these particular services, you shall be subject to any 
              posted guidelines or rules applicable to such services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">2. Description of Service</h2>
            <p>
              Missed Call Rescue provides automated customer service and lead capture solutions. We reserve the right to modify, 
              suspend, or discontinue the service with or without notice at any time and without any liability to you.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">3. User Conduct</h2>
            <p>
              You agree to use our services only for lawful purposes. You are prohibited from any use of the services that would 
              constitute a violation of any applicable law, regulation, rule or ordinance of any nationality, state, or locality 
              or of any international law or treaty.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">4. Intellectual Property</h2>
            <p>
              All content included on this site, such as text, graphics, logos, button icons, images, audio clips, digital 
              downloads, data compilations, and software, is the property of Missed Call Rescue or its content suppliers and 
              protected by international copyright laws.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">5. Limitation of Liability</h2>
            <p>
              In no event shall Missed Call Rescue, nor its directors, employees, partners, agents, suppliers, or affiliates, 
              be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, 
              loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or 
              inability to access or use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-3">6. Contact Information</h2>
            <p>
              If you have any questions about these Terms, please contact us at:
              <br />
              <strong>Email:</strong> missedcallrescuecanada@gmail.com
              <br />
              <strong>Phone:</strong> 1-855-780-3522 or 780-237-6933
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
};

export default TermsOfService;
